import React from 'react'
import { connect } from 'react-redux'
import { PatientCategoryList, PatientContent, PatientCareCenterHomeHeader } from 'PatientCareCenter/Home'
import styles from './Home.module.css';
import { LoadingIcon } from '_components';

class PatientCareCenterHome extends React.Component {

    render() {
        if (this.props.patient) {

            return (
                <div className={styles.home_contents} >
                    <div className={styles.header_wrapper}>
                        <PatientCareCenterHomeHeader />
                    </div>
                    <div className={styles.content_wrapper}>
                        <div className={styles.category_list}>
                            <PatientCategoryList />
                        </div>
                        <div className={styles.content}>
                            <PatientContent />
                        </div>
                    </div>

                </div>

            );
        } else {
            return (
                <div className={styles.loading_div}>
                    <label>Loading...</label>
                    <LoadingIcon size='large' />
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        patient: state.entities.patients[state.ui.patients.selectedPtno],
    };
}

const connectedPatientCareCenterHome = connect(mapStateToProps)(PatientCareCenterHome);
export { connectedPatientCareCenterHome as PatientCareCenterHome };
